import { CircularProgress, Grid2 as Grid, Typography } from '@mui/material'
import AccordionBase from 'components/Accordion'
import { useEffect, useState } from 'react'
import { getFAQList } from 'services/faq'
import { IFaqResponse } from 'types/faq/types'
import FAQSkeleton from './skeleton'

export const FAQPage = () => {
  const [state, setState] = useState<IStateStdTypes>('idle')
  const [list, setList] = useState<IFaqResponse[]>([])

  useEffect(() => {
    const fetch = async () => {
      const response = await getFAQList()
      if (response.success) {
        setList(response.data!)
        setState('success')
      } else {
        setState('error')
      }
    }
    setState('loading')
    fetch()
  }, [])

  const Title: React.FC<{ title: string }> = ({ title }) => (
    <Grid size={12}>
      <Typography variant='h6'>{title}</Typography>
    </Grid>
  )

  const renderItem = (item: IFaqResponse, index: number) => (
    <Grid key={index} size={12}>
      <AccordionBase title={item.question}>
        <Typography>{item.answer}</Typography>
      </AccordionBase>
    </Grid>
  )

  const render = {
    idle: <></>,
    loading: <FAQSkeleton />,
    success: (
      <Grid container size={12} spacing={3}>
        <Title title='Pacientes' />
        <Grid container spacing={2}>
          {list
            .filter(i => i.type === 'patient')
            .map((element, index) => renderItem(element, index))}
        </Grid>
        <Title title='Médicos' />
        <Grid container spacing={2}>
          {list
            .filter(i => i.type === 'doctor')
            .map((element, index) => renderItem(element, index))}
        </Grid>
        <Grid container spacing={2}>
          <Title title='Técnico' />
          {list
            .filter(i => i.type === 'technical')
            .map((element, index) => renderItem(element, index))}
        </Grid>
      </Grid>
    ),
    error: <Grid></Grid>
  }

  return (
    <Grid
      container
      spacing={2}
      p={2}
      margin='0 auto'
      width='100%'
      maxWidth={1200}
    >
      <Grid size={12} display='flex' justifyContent='space-between'>
        <Typography variant='h5'>Perguntas Frequentes</Typography>
      </Grid>
      {render[state]}
    </Grid>
  )
}
